var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3569_704",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3569_704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.02935 4.13061C8.77008 4.13061 9.37032 4.72909 9.37032 5.46765C9.37032 6.20621 8.77008 6.8047 8.02935 6.8047C7.28863 6.8047 6.68838 6.20621 6.68838 5.46765C6.68838 4.72909 7.28863 4.13061 8.02935 4.13061ZM8.02935 9.8608C9.92587 9.8608 11.9245 10.7904 11.9245 11.1978V11.8982H4.13416V11.1978C4.13416 10.7904 6.13284 9.8608 8.02935 9.8608ZM8.02935 2.9209C6.61814 2.9209 5.47513 4.06057 5.47513 5.46765C5.47513 6.87473 6.61814 8.01441 8.02935 8.01441C9.44056 8.01441 10.5836 6.87473 10.5836 5.46765C10.5836 4.06057 9.44056 2.9209 8.02935 2.9209ZM8.02935 8.65109C6.32441 8.65109 2.9209 9.50426 2.9209 11.1978V13.1079H13.1378V11.1978C13.1378 9.50426 9.7343 8.65109 8.02935 8.65109Z",
    fill: "#0d99ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcn);
export default __webpack_public_path__ + "static/media/logoutIcn.e39a5450a848180528af23abec505684.svg";
export { ForwardRef as ReactComponent };